// shadowed constants for RelatedArticleCard
export const articleShortTitleTextLength = 90;
export const articleIntroductionMobileTextLength = 90;
export const articleIntroductionDesktopTextLength = 130;
